'use strict';

var cov_qkngaatgi = function () {
  var path = '/Users/ryanluton/Developer/divcon/divcon-tools/src/app/users/user-list/user-list.js',
      hash = 'a8b1d21b56f6e5b42c5d48fb824616e2be940f61',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/ryanluton/Developer/divcon/divcon-tools/src/app/users/user-list/user-list.js',
    statementMap: {
      '0': {
        start: {
          line: 2,
          column: 0
        },
        end: {
          line: 37,
          column: 5
        }
      },
      '1': {
        start: {
          line: 3,
          column: 19
        },
        end: {
          line: 6,
          column: 3
        }
      },
      '2': {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 43
        }
      },
      '3': {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 21
        }
      },
      '4': {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 20,
          column: 6
        }
      },
      '5': {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 31
        }
      },
      '6': {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 23
        }
      },
      '7': {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 31,
          column: 6
        }
      },
      '8': {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 30,
          column: 7
        }
      },
      '9': {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 29,
          column: 13
        }
      },
      '10': {
        start: {
          line: 26,
          column: 12
        },
        end: {
          line: 26,
          column: 26
        }
      },
      '11': {
        start: {
          line: 28,
          column: 12
        },
        end: {
          line: 28,
          column: 26
        }
      },
      '12': {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 36,
          column: 37
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 1
          },
          end: {
            line: 2,
            column: 2
          }
        },
        loc: {
          start: {
            line: 2,
            column: 13
          },
          end: {
            line: 37,
            column: 1
          }
        }
      },
      '1': {
        name: 'userListCtrl',
        decl: {
          start: {
            line: 10,
            column: 11
          },
          end: {
            line: 10,
            column: 23
          }
        },
        loc: {
          start: {
            line: 10,
            column: 37
          },
          end: {
            line: 32,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 13,
            column: 19
          },
          end: {
            line: 13,
            column: 20
          }
        },
        loc: {
          start: {
            line: 13,
            column: 25
          },
          end: {
            line: 20,
            column: 5
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 22,
            column: 22
          },
          end: {
            line: 22,
            column: 23
          }
        },
        loc: {
          start: {
            line: 22,
            column: 29
          },
          end: {
            line: 31,
            column: 5
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 25,
            column: 16
          },
          end: {
            line: 25,
            column: 17
          }
        },
        loc: {
          start: {
            line: 25,
            column: 23
          },
          end: {
            line: 27,
            column: 11
          }
        }
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 27,
            column: 19
          },
          end: {
            line: 27,
            column: 20
          }
        },
        loc: {
          start: {
            line: 27,
            column: 26
          },
          end: {
            line: 29,
            column: 11
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 30,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 30,
            column: 7
          }
        }, {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 30,
            column: 7
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0
    },
    b: {
      '0': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_qkngaatgi.s[0];
(function () {
  ++cov_qkngaatgi.f[0];

  var userList = (++cov_qkngaatgi.s[1], {
    templateUrl: 'app/users/user-list/user-list.html',
    controller: userListCtrl
  });

  ++cov_qkngaatgi.s[2];
  userListCtrl.$inject = ['Users', '$log'];

  function userListCtrl(Users, $log) {
    ++cov_qkngaatgi.f[1];

    var self = (++cov_qkngaatgi.s[3], this);

    ++cov_qkngaatgi.s[4];
    self.$onInit = function () {
      ++cov_qkngaatgi.f[2];
      ++cov_qkngaatgi.s[5];

      self.users = Users.all();
      ++cov_qkngaatgi.s[6];
      self.filter = '';
      // Timesheets.employees()
      //   .then(employees => {
      //     self.employees = employees;
      //   });
    };

    ++cov_qkngaatgi.s[7];
    self.removeUser = function (uid) {
      ++cov_qkngaatgi.f[3];
      ++cov_qkngaatgi.s[8];

      if (uid) {
        ++cov_qkngaatgi.b[0][0];
        ++cov_qkngaatgi.s[9];

        Users.remove(uid).then(function (res) {
          ++cov_qkngaatgi.f[4];
          ++cov_qkngaatgi.s[10];

          $log.log(res);
        }).catch(function (err) {
          ++cov_qkngaatgi.f[5];
          ++cov_qkngaatgi.s[11];

          $log.log(err);
        });
      } else {
        ++cov_qkngaatgi.b[0][1];
      }
    };
  }

  ++cov_qkngaatgi.s[12];
  angular.module('app').component('userList', userList);
})();